import useDefinedContext from "hooks/useDefinedContext";
import ChartPersonalBestsContext from "../ChartPersonalBestsContext";

function useChartPersonalBests() {
  return useDefinedContext(ChartPersonalBestsContext);
}

export default useChartPersonalBests;
